import React from 'react';
import {
  Flex,
  Heading,
  Text,
  Icon,
  Box,
  Avatar,
  AvatarGroup,
  Badge,
  SimpleGrid,
  useColorModeValue,
} from '@chakra-ui/react';
import { MdGroups } from 'react-icons/md';
import Card from 'components/card/Card.js';

const EQUIPES_MOCK = [
  { nome: 'Equipe Alpha',  lider: 'Carlos Silva',   membros: 4, ativas: 2 },
  { nome: 'Equipe Beta',   lider: 'Ana Souza',       membros: 3, ativas: 1 },
  { nome: 'Equipe Gamma',  lider: 'Roberto Lima',    membros: 5, ativas: 3 },
];

/**
 * Gestão de Equipes / Técnicos
 * TODO: cadastro de equipes, atribuição de técnicos, histórico de OS por equipe
 */
export default function Equipes() {
  const textColor = useColorModeValue('navy.700', 'white');
  const subText = useColorModeValue('gray.500', 'gray.400');
  const cardBg = useColorModeValue('white', 'navy.800');

  return (
    <Flex direction="column" pt={{ base: '8px', md: '16px', xl: '0px' }}>
      {/* Header */}
      <Card p="6" mb="6">
        <Flex align="center" gap="12px" mb="4">
          <Icon as={MdGroups} boxSize="30px" color="brand.500" />
          <Box>
            <Heading size="md" color={textColor}>
              Gestão de Equipes
            </Heading>
            <Text fontSize="sm" color={subText}>
              Visualize e gerencie as equipes de campo e seus técnicos
            </Text>
          </Box>
        </Flex>
        <Badge colorScheme="blue" fontSize="sm" px="3" py="1" borderRadius="full">
          Dados de exemplo — integração com cadastro em desenvolvimento
        </Badge>
      </Card>

      {/* Cards de equipes */}
      <SimpleGrid columns={{ base: 1, md: 3 }} gap="20px">
        {EQUIPES_MOCK.map((eq) => (
          <Card key={eq.nome} p="6" bg={cardBg}>
            <Flex justify="space-between" align="flex-start" mb="4">
              <Box>
                <Text fontWeight="bold" color={textColor} fontSize="md">
                  {eq.nome}
                </Text>
                <Text fontSize="sm" color={subText}>
                  Líder: {eq.lider}
                </Text>
              </Box>
              <Badge colorScheme="green" borderRadius="full" px="2">
                {eq.ativas} OS ativas
              </Badge>
            </Flex>
            <Flex align="center" gap="3">
              <AvatarGroup size="sm" max={4}>
                {Array.from({ length: eq.membros }).map((_, i) => (
                  <Avatar key={i} name={`T${i + 1}`} />
                ))}
              </AvatarGroup>
              <Text fontSize="xs" color={subText}>
                {eq.membros} técnico{eq.membros > 1 ? 's' : ''}
              </Text>
            </Flex>
          </Card>
        ))}
      </SimpleGrid>
    </Flex>
  );
}
